const FILLED_EXIT_LEVEL_STATUS = 'FILLED';

export const normalizeExitLevelStatus = (status) => (
  typeof status === 'string' ? status.trim().toUpperCase() : ''
);

export const isFilledExitLevel = (level) => (
  normalizeExitLevelStatus(level?.status) === FILLED_EXIT_LEVEL_STATUS
);

export const filterVisibleChartExitLevels = (levels = []) => (
  (levels || [])
    .map((level, index) => ({
      ...level,
      chartLevelNumber: index + 1,
    }))
    .filter(level => !isFilledExitLevel(level))
);
